import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { rootTranslation } from 'utils/format';
import { useFormContext } from 'react-hook-form';

const t = rootTranslation('drawers.productionSetup.tracks');

export function CreateNewButton() {
  const { setValue, getValues } = useFormContext();

  return (
    <Button
      variant="outlined"
      color="secondary"
      size="small"
      startIcon={<AddIcon />}
      onClick={() => {
        // Preserve the search values when switching to create mode
        const currentTitle = getValues('title');
        const currentArtist = getValues('artist');

        setValue('contentMode', 'create');
        // Keep the title and artist from search, only clear libraryTrackId
        setValue('artist', currentArtist || '');
        setValue('title', currentTitle || '');
        setValue('libraryTrackId', '');
      }}
    >
      {t('filter.createNew')}
    </Button>
  );
}
